// extracted by mini-css-extract-plugin
export default {"sigContainer":"styles_sigContainer__rVDut","sigPad":"styles_sigPad__j73j7","sigImage":"styles_sigImage__zNOyw"};